import LoggedInAsBrand from './LoggedInAsBrand';

export default LoggedInAsBrand;
